export const MODAL_MESSAGES = {
  DELETE_COMMENT: "本当にこのコメントを削除しますか？",
  DISCARD_EDIT:
    "編集中のコメントが保存されていません。\n入力内容を破棄しますか？",
  HIDE_COMMENT: "このコメントを非表示にしてよろしいですか？",
  SHOW_COMMENT: "このコメントを再度表示してよろしいですか？",
  DISCARD_PICO_INPUT:
    "入力中の内容が保存されていません。\n入力内容を破棄しますか？",
} as const;
